import { render, staticRenderFns } from "./BodyBox.vue?vue&type=template&id=66a02b0a&scoped=true"
var script = {}
import style0 from "./BodyBox.vue?vue&type=style&index=0&id=66a02b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a02b0a",
  null
  
)

export default component.exports